import "./filter";
import "./visible";
import "./dragscroll";
import Macy from "./macy";
import "../cookies_modal/cookies_modal";
import "./extra_functions";
